import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBadgeModule } from '@angular/material/badge';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { PaymentsListFilterDialogModule } from '../payments-list-filter-dialog/payments-list-filter-dialog.module';
import { PaymentsRefundDialogModule } from '../payments-refund-dialog/payments-refund-dialog.module';
import { PaymentsListTabComponent } from './payments-list-tab.component';

@NgModule({
  declarations: [PaymentsListTabComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatBadgeModule,
    PaymentsListFilterDialogModule,
    PaymentsRefundDialogModule,
    WsUiModule,
  ],
  exports: [PaymentsListTabComponent],
})
export class PaymentsListTabModule {}
